import { defineMessages, useIntl } from 'react-intl';
import { type BlockEditProps } from '@plone/types';
import './pagetitlewithmenu.scss';
import Menu from '../PageTitleWithMenu/menu';
import { type PageTitleWithParentMenuData } from './View';

const messages = defineMessages({
  navigation_placeholder: {
    id: 'navigation_placeholder',
    defaultMessage: 'Navigation will be loaded after first save',
  },
});

type Props = BlockEditProps & {
  data: PageTitleWithParentMenuData;
};

export const EditPageTitleWithParentMenuBlock = (props: Props) => {
  const { data, properties } = props;
  const intl = useIntl();

  return (
    <div className="product-title-wrapper">
      <div className="product-title">
        <p className="h1 documentFirstHeading">
          {data?.parent?.title || properties?.parent?.title}
        </p>
        <h1 className="sr-only">{properties?.title}</h1>
      </div>
      <div className="product-navigation" contentEditable="plaintext-only">
        {data?.parent_items ? (
          <Menu items={data?.parent_items || []} isEditMode={true} />
        ) : (
          <p className="no-menu-message">
            {intl.formatMessage(messages.navigation_placeholder)}
          </p>
        )}
      </div>
    </div>
  );
};

export default EditPageTitleWithParentMenuBlock;
